import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: `Nous sommes désolés que cet article ne vous ait pas été utile. Pouvez-vous nous indiquer ce qui n'allait pas ?`,
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Les informations que je recherche sont manquantes.',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Il y a des erreurs factuelles.',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Certaines questions ne sont pas claires.',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Donnez-nous quelques informations générales et nous améliorerons cet article.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Send'
    }
  }
};
